import embedPowerBiView from './embedPowerBiComponent.html';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { parse } from 'components/sharpr/url/serializer/urlSerializer.js';
import './embedPowerBiComponent.css';
import _ from 'lodash';

export function embedPowerBiComponent() {
	return {
		bindings: {
			embed: '<',
		},
		controllerAs: 'vm',
		controller: embedPowerBiComponentCtrl,
		template: embedPowerBiView,
	};
}

export class embedPowerBiComponentCtrl {
	constructor($element) {
		'ngInject';
		this.$element = $element;
		this.scriptPromise = AssetManager.script(
			// release info: https://github.com/microsoft/PowerBI-JavaScript/releases
			'https://unpkg.com/powerbi-client@2.7.5/dist/powerbi.min.js'
		);
		this.scriptPromise.then(
			() => {
				this.load();
			},
			() => {
				this.error = true;
			}
		);
	}

	$onInit() {
		this.size = {};
		if (this.embed.width) {
			this.size.width = this.embed.width + 'px';
		}
		if (this.embed.height) {
			this.size.height = this.embed.height + 'px';
		}
	}

	/**
	 * Use the PowerBI JavaScript API to render the embed
	 * @see https://microsoft.github.io/PowerBI-JavaScript/demo/v2-demo/index.html
	 */
	load() {
		const div = this.$element[0].querySelector('.embed-container');
		const models = window['powerbi-client'].models;
		let url = new URL(this.embed.url);
		let params = parse(url.search);
		let config = {};
		// Build config based on which kind of embed we have
		if (params.tileId && params.dashboardId) {
			// TILE EMBED
			// tile URL: https://app.powerbi.com/embed?dashboardId=b5f50796-6e97-4dc5-a755-00cf4405e029&tileId=e9c81853-3263-4f30-af4b-63fad7d79627&groupId=be8908da-da25-452e-b220-163f52476cdd&config=
			config = {
				type: 'tile',
				embedUrl: this.embed.url,
				id: params.tileId,
				dashboardId: params.dashboardId,
			};
		} else if (params.dashboardId) {
			// DASHBOARD EMBED
			// dashboard URL: https://app.powerbi.com/dashboardEmbed?dashboardId=b5f50796-6e97-4dc5-a755-00cf4405e029&groupId=be8908da-da25-452e-b220-163f52476cdd&config=
			config = {
				type: 'dashboard',
				embedUrl: this.embed.url,
				id: params.dashboardId,
				pageView: 'fitToWidth',
			};
		} else if (params.reportId) {
			// REPORT/PAGINATED/VISUAL EMBED
			// report URL: https://app.powerbi.com/reportEmbed?reportId=f6bfd646-b718-44dc-a378-b73e6b528204&groupId=be8908da-da25-452e-b220-163f52476cdd&config=
			// paginated URL: https://app.powerbi.com/rdlEmbed?reportId=09b1aef6-4987-4f99-810d-83c8e28ffc6d&config=
			// visual URL: https://app.powerbi.com/reportEmbed?reportId=f6bfd646-b718-44dc-a378-b73e6b528204&groupId=be8908da-da25-452e-b220-163f52476cdd&config=
			config = {
				type: 'report',
				embedUrl: this.embed.url,
				id: params.reportId,
				permissions: models.Permissions.All,
				settings: {
					filterPaneEnabled: true,
					navContentPaneEnabled: true,
				},
				// for visual embed, this.embed.advanced must contain:
				// pageName
				// visualName
			};
		} else if (this.embed.url.includes('/qnaEmbed')) {
			// Q&A EMBED
			// https://app.powerbi.com/qnaEmbed?groupId=be8908da-da25-452e-b220-163f52476cdd
			config = {
				type: 'qna',
				embedUrl: this.embed.url,
				viewMode: models.QnaMode.Interactive,
				// this.embed.advanced must contain:
				// dataSetIds
				// question
			};
		}
		// add auth information
		if (this.embed.auth_type === 'aad') {
			config.tokenType = models.TokenType.Aad;
		} else if (this.embed.auth_type === 'embed') {
			config.tokenType = models.TokenType.Embed;
		}
		if (this.embed.auth_value) {
			config.accessToken = this.embed.auth_value;
		}
		let advanced;
		try {
			advanced = JSON.parse(this.embed.advanced || '{}') || {};
		} catch (e) {
			advanced = {};
		}
		const finalConfig = _.defaultsDeep(advanced, config);
		window.powerbi.embed(div, finalConfig);
	}
}
